// extracted by mini-css-extract-plugin
export default {"titleBox":"_iJ4NYkG_mXEmQWegZY3","titleRow":"Oudv1a2xq6TEO0izWYak","title":"sA9dagGZ7msQLjmiKEjQ","marginBottom":"S746GlfpjEHadoVjgM1a","marginTop":"Z20_plZnMDTvS7wOYjVf"};